import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Modal,
  TableCell,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  Typography,
} from "@mui/material";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
};

const Holiday = () => {
  const [openModal, setOpenModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [leaveStatus, setLeaveStatus] = useState({});
  const [newHoliday, setNewHoliday] = useState({ holiday: "", date: "" });

  const [holidayData, setHolidayData] = useState([
    { id: 1, day: "Monday", date: "2025-01-01", name: "New Year" },
    { id: 2, day: "Friday", date: "2025-12-25", name: "Christmas" },
    { id: 3, day: "Monday", date: "2025-01-01", name: "New Year" },
    { id: 4, day: "Friday", date: "2025-12-25", name: "Christmas" },
  ]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setNewHoliday({ ...newHoliday, [name]: value });
  };

  const handleAddHoliday = (e) => {
    e.preventDefault();
    setHolidayData([...holidayData, { id: holidayData.length + 1, ...newHoliday }]);
    setNewHoliday({ holiday: "", date: "" });
    setOpenModal(false);
  };

  const handleModalOpen = (leave) => {
    setSelectedLeave(leave);
    setConfirmationModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setConfirmationModal(false);
  };

  const handleAction = (action) => {
    if (selectedLeave) {
      setLeaveStatus((prev) => ({ ...prev, [selectedLeave.id]: action }));
    }
    handleModalClose();
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#000" }}>
          Holidays
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ backgroundColor: "#2F3B57", display: "flex", alignItems: "center", gap: 1 }}
          onClick={() => setOpenModal(true)}
        >
          <AddCircleOutlineOutlinedIcon sx={{ marginRight: 1 }} /> Add Holiday
        </Button>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Holiday Day</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Holiday Date</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Holiday Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {holidayData.map((entry) => (
              <TableRow key={entry.id}>
                <TableCell sx={{ color: "#b8860b", fontWeight: "bold" }}>{entry.id}</TableCell>
                <TableCell>{entry.day}</TableCell>
                <TableCell>{entry.date}</TableCell>
                <TableCell>{entry.name}</TableCell>
              
                <TableCell>
                  <CheckCircleIcon sx={{ color: "green", cursor: "pointer", mr: 1 }} onClick={() => handleModalOpen(entry)} />
                  <CancelIcon sx={{ color: "red", cursor: "pointer" }} onClick={() => handleModalOpen(entry)} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal open={openModal} onClose={handleModalClose}>
        <Box sx={style}>
          <ModalHeader title="Add Holiday" handleClose={handleModalClose} />
          <form onSubmit={handleAddHoliday}>
            <Grid container spacing={2}>
              <Grid item xs={12}><TextField label="Holiday Name" name="name" fullWidth required onChange={handleFieldChange} value={newHoliday.holiday} /></Grid>
              <Grid item xs={12}><TextField label="Holiday Date" type="date" name="date" fullWidth required onChange={handleFieldChange} value={newHoliday.date} InputLabelProps={{ shrink: true }} /></Grid>
            </Grid>
            <ModalFooter handleClose={handleModalClose} btnText="Add Holiday" disable={!Object.values(newHoliday).every(Boolean)} />
          </form>
        </Box>
      </Modal>
    </Box>
  );
};

export default Holiday;
